import { render, staticRenderFns } from "./Type3Verify.vue?vue&type=template&id=1fcd30f3"
import script from "./Type3Verify.vue?vue&type=script&lang=js"
export * from "./Type3Verify.vue?vue&type=script&lang=js"
import style0 from "./Type3Verify.vue?vue&type=style&index=0&id=1fcd30f3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports